import { useEffect } from 'react'
import { useLocation } from 'react-router'

import { EMPTY_STRING } from '../../../constants/common'
import { ROUTER_EXTERNAL_REDIRECT_PREFIX } from '../../../constants/route'
import { Loader } from '../../Loader'

function RouteRedirectExternal() {
  const location = useLocation()

  useEffect(() => {
    window.location.replace(
      location.pathname.replace(
        `/${ROUTER_EXTERNAL_REDIRECT_PREFIX}`,
        EMPTY_STRING
      ) + location.search
    )
  }, [location])

  return <Loader />
}

export default RouteRedirectExternal
